import Vue from 'vue'
import Router from 'vue-router'
import { dropOrigin } from '@/utils/url'
import originRedirect from '@/utils/originRedirect'
import Nest from './views/Nest'
import Login from './views/Login'
import SendMail from './views/Login/SendMail'
import Complete from './views/Login/Complete'
import Registration from './views/Login/Registration'
import RegistrationComplete from './views/Login/RegistrationComplete'
import Store from './views/Store'
import Insert from './views/MailAddress/Insert'
import PasswordReset from './views/Password/Reset'
import ReserveDetail from './views/ReserveDetail'
import ReserveHistory from './views/ReserveHistory'
import Alert from './views/Alert'
import Customer from './views/Customer'
import CustomerCsvDownload from './views/Customer/Csv/Download'
import CustomerCsvUpload from './views/Customer/Csv/Upload'
import Download from './views/Download'
import MailBox from './views/MailBox'
import MailConversion from './views/MailConversion'
import MailConversionConfirm from './views/MailConversion/confirm'
import Option from './views/Setting/Customer/Option'
import OptionOrder from './views/Setting/Customer/OptionOrder'
import Help from './views/Help'
import Storetransfer from './views/Storetransfer'
import Resraku from './views/Resraku'
import ResrakuEdit from './views/Resraku/edit'
import User from './views/User'
import Staff from './views/Staff'
import StaffOrder from './views/Staff/StaffOrder'
import CourseMenu from './views/CourseMenu'
import CourseMenuOrder from './views/CourseMenu/CourseMenuOrder'
import Analysis from './views/Analysis'
import AnalysisDashBoard from './views/Analysis/DashBoard'
import AnalysisCustomer from './views/Analysis/Customer'
import AnalysisRoute from './views/Analysis/Route'
import AnalysisCall from './views/Analysis/Call'
import AnalysisCourseMenu from './views/Analysis/CourseMenu'
import AnalysisTag from './views/Analysis/Tag'
import AnalysisCancel from './views/Analysis/Cancel'
import AnalysisTarget from './views/Analysis/Target'
import AnalysisProgress from './views/Analysis/Progress'
import Businesshour from './views/Businesshour'
import Ivr from './views/Ivr'
import IvrTime from './views/Ivr/Time'
import IvrOrder from './views/Ivr/Order'
import IvrEdit from './views/Ivr/Edit'
import IvrDownload from './views/Ivr/Download'

import store from './store'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: BASE_PATH,
  scrollBehavior: (to, from, savedPosition) => savedPosition || { x: 0, y: 0 },
  routes: [
    ...(STAGE === STAGE_LOCAL
      ? [
          {
            path: '/(index.html)?',
            component: require('./views/Index.vue').default,
            beforeEnter: (to, from, next) => {
              next(originRedirect()(to))
            },
          },
        ]
      : []),
    {
      path: '/login',
      component: Nest,
      children: [
        {
          path: 'open',
          name: 'Login',
          component: Login,
          beforeEnter: (to, from, next) => {
            if (['SendMail', 'Registration'].includes(from.name)) {
              store.dispatch('login/setLoginData', { password: '' })
            }
            return next()
          },
        },
        {
          path: 'open/PreRegistration',
          name: 'PreRegistration',
          component: Login,
          beforeEnter: (to, from, next) => {
            store.dispatch('login/setLoginData', { mail: '', password: '', isTemporary: true })
            return next()
          },
        },
        { path: 'open/sendMail', name: 'SendMail', component: SendMail },
        { path: 'open/complete', name: 'Complete', component: Complete },
        {
          path: 'open/registration',
          name: 'Registration',
          component: Registration,
          beforeEnter: (to, from, next) => {
            if (!store.state.login.login.token) return next({ name: 'Login', replace: true })
            return next()
          },
        },
        {
          path: 'open/registrationComplete',
          name: 'RegistrationComplete',
          component: RegistrationComplete,
          beforeEnter: (to, from, next) => {
            if (!store.state.login.login.token) return next({ name: 'Login', replace: true })
            return next()
          },
        },
        { path: '', redirect: 'open' },
        { path: '*', redirect: 'open' },
      ],
    },
    { path: '/password/update', alias: '/password/update/complete', component: PasswordReset },
    {
      path: '/store/init',
      name: 'Store',
      component: Store,
      beforeEnter: async (to, from, next) => {
        await store.dispatch('stores/sync/get')
        return next()
      },
    },
    {
      path: '/manage/ivr',
      component: Nest,
      beforeEnter: async (to, from, next) => {
        await store.dispatch('ivr/list/get', true)
        return next()
      },
      children: [
        { path: 'init', name: 'Ivr', component: Ivr },
        { path: 'time', name: 'IvrTime', component: IvrTime },
        { path: 'order', name: 'IvrOrder', component: IvrOrder },
        { path: 'edit', name: 'IvrEdit', component: IvrEdit },
        { path: 'download', name: 'IvrDownload', component: IvrDownload },
      ],
    },
    { path: '/businesshour/init', name: 'Businesshour', component: Businesshour },
    { path: '/reservation/history', component: ReserveHistory },
    {
      path: '/reservation/history/detail',
      component: ReserveDetail,
      beforeEnter: addBackTo,
      props: ({ query }) => ({
        id: query.reservation_id && +query.reservation_id,
        alertType: query.alert_type && +query.alert_type,
        backTo: dropOrigin(query.backTo),
      }),
    },
    {
      path: '/alert',
      alias: '/alert/init',
      component: Alert,
      beforeEnter: addBackTo,
      props: ({ query }) => ({
        backTo: dropOrigin(query.backTo),
      }),
    },
    {
      path: '/customer',
      component: Nest,
      beforeEnter: addBackTo,
      children: [
        {
          path: 'init',
          alias: '',
          name: 'Customers',
          component: Customer,
          beforeEnter: async (to, from, next) => {
            const { customer_id: id, ...query } = to.query
            if (id) {
              return next({
                name: 'CustomerDetail',
                params: { id: +id, onlyEdit: true },
                query: { ...query },
                replace: true,
              })
            }
            return next()
          },
          props: ({ query: { backTo } }) => ({ backTo: dropOrigin(backTo) }),
        },
        {
          path: 'new',
          name: 'CustomerAdd',
          component: Customer,
          props: ({ query: { backTo } }) => ({ id: 'new', backTo: dropOrigin(backTo) }),
        },
        {
          path: ':id',
          name: 'CustomerDetail',
          component: Customer,
          props: ({ params: { id, onlyEdit }, query: { backTo } }) => ({
            id: id && +id,
            onlyEdit,
            backTo: dropOrigin(backTo),
          }),
        },
        {
          path: 'csv',
          component: Nest,
          beforeEnter: async (to, from, next) => {
            await store.dispatch('stores/current/get', {
              id: +to.query.selected_store_id || null,
              token: to.query.token,
            })
            if (!store.state.stores.current.store.isTokenAlive) {
              store.state.optional.errorType = 3
            }
            return next()
          },
          children: [
            {
              path: 'download',
              name: 'CustomerCsvDownload',
              component: CustomerCsvDownload,
            },
            {
              path: 'upload',
              name: 'CustomerCsvUpload',
              component: CustomerCsvUpload,
            },
          ],
        },
      ],
    },
    { path: '/download', name: 'download', component: Download },
    { path: '/mailbox', name: 'MailBox', component: MailBox },
    {
      path: '/mailconversion',
      component: Nest,
      children: [
        {
          name: 'MailConversion',
          path: 'init',
          component: MailConversion,
          props: true,
        },
        {
          name: 'MailConversionConfirm',
          path: 'confirm',
          component: MailConversionConfirm,
          beforeEnter: async (to, from, next) => {
            await store.dispatch('mailConversion/get')
            return store.state.mailConversion.settings.termAgreement
              ? next({ name: 'MailConversion', replace: true })
              : next()
          },
        },
      ],
    },
    {
      path: '/mailAddress/insert',
      name: 'Insert',
      component: Insert,
      beforeEnter: async (to, from, next) => {
        if (!to.query.token || !(await store.dispatch('login/regist', to.query.token))) {
          return next({ name: 'Login', replace: true })
        }
        return next()
      },
    },
    {
      path: '/setting/customer/option/',
      component: Nest,
      children: [
        {
          name: 'option',
          path: '',
          component: Option,
        },
        {
          name: 'optionOrder',
          path: 'order',
          component: OptionOrder,
        },
      ],
    },
    { path: '/help', name: 'help', component: Help },
    {
      path: '/storetransfer',
      name: 'Storetransfer',
      component: Storetransfer,
    },
    {
      path: '/resraku/',
      component: Nest,
      children: [
        { path: '', name: 'Resraku', component: Resraku },
        {
          path: 'edit',
          name: 'ResrakuEdit',
          component: ResrakuEdit,
          props: ({ params }) => ({ table: params.table }),
          beforeEnter: async (to, from, next) => {
            if (!to.params.table) return next({ name: 'Resraku', replace: true })
            return next()
          },
        },
      ],
    },
    { path: '/user/init', name: 'user', component: User },
    {
      path: '/staff',
      component: Nest,
      children: [
        {
          name: 'staff',
          path: 'init',
          component: Staff,
        },
        {
          name: 'staffOrder',
          path: 'order',
          component: StaffOrder,
        },
      ],
    },
    {
      path: '/coursemenu',
      component: Nest,
      children: [
        {
          name: 'coursemenu',
          path: 'init',
          component: CourseMenu,
        },
        {
          name: 'coursemenuOrder',
          path: 'order',
          component: CourseMenuOrder,
        },
      ],
    },
    {
      path: '/analysis/',
      component: Analysis,
      children: [
        { path: 'dashboard', name: 'dashboard', component: AnalysisDashBoard },
        { path: 'customer', name: 'customer', component: AnalysisCustomer },
        { path: 'route', name: 'route', component: AnalysisRoute },
        { path: 'call', name: 'call', component: AnalysisCall },
        { path: 'coursemenu', name: 'analysisCoursemenu', component: AnalysisCourseMenu },
        { path: 'tag', name: 'tag', component: AnalysisTag },
        { path: 'cancel', name: 'cancel', component: AnalysisCancel },
        { path: 'target', name: 'target', component: AnalysisTarget },
        { path: 'progress', name: 'progress', component: AnalysisProgress },
        { path: '', redirect: 'dashboard' },
        { path: '*', redirect: 'dashboard' },
      ],
    },
  ],
})

function addBackTo({ path, query }, from, next) {
  if (!query.backTo) {
    const referrer = dropOrigin(document.referrer || '/')
    return next({
      path,
      query: {
        ...query,
        backTo: referrer.includes('edit') ? '/' : referrer,
      },
      replace: true,
    })
  }
  return next()
}
